const Reflux = require('@muzzylane/reflux');

const Globals = require('../../../app/globals');
const GoogleClassroomActions = require('../actions/GoogleClassroomActions');

let action = {};
let _gapi_state = Globals.GAPI_LoadState.START;
let _sign_in_clicked = false;

const GoogleClassroomStore = Reflux.createStore({
    listenables: [GoogleClassroomActions],
    init: () => { return; },

    resetState: function() {
		_gapi_state = Globals.GAPI_LoadState.START; // is there an any reason to do this?
        _sign_in_clicked = false;
    },

    getState: function() {
        return {
			_gapi_state: _gapi_state,
            _sign_in_clicked: _sign_in_clicked,
        };
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onSetGapiStateCompleted: function(newState) {
    	_gapi_state = newState;
    	this.emitStatus();
    },

    onSetSignInClickedState: function(newState) {
        _sign_in_clicked = newState;
        this.emitStatus();
    }
});

module.exports = GoogleClassroomStore;